import { Box, Card, Grid, Typography } from '@mui/material'
import dayjs from 'dayjs'
import React from 'react'
import Palette from '../../theme/palette'

const Overview = ({ data, isLoading }) => {
  return (
    <div>
      {isLoading ? (
        <Card style={{ display: 'flex', justifyContent: 'center', paddingBottom: "70px" }}>
          <span className="loader" />
        </Card>
      ) : (
        <Card style={{ borderTopLeftRadius: "0px", borderTopRightRadius: "0px" }}>
          <Box p={3}>
            <Grid container display="flex" spacing={4}>
              <Grid item xs={12} sm={6}>
                <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} pb={2}>
                  <Typography variant="body1">Project number :</Typography>
                  <Typography variant="body2" color={Palette.grey[600]}>{data?.projectNumber ? data?.projectNumber : "--"}</Typography>
                </Grid>
                <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400], }} py={2}>
                  <Typography variant="body1">Project type :</Typography>
                  <Typography variant="body2" color={Palette.grey[600]} >{data?.projectType ? data?.projectType : "--"}</Typography>
                </Grid>
                <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                  <Typography variant="body1">Project start date :</Typography>
                  <Typography variant="body2" color={Palette.grey[600]} >
                    {
                      data?.projectStartDate ? dayjs(data?.projectStartDate).format("DD/MM/YYYY") : "--"
                    }
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} pb={2}>
                  <Typography variant="body1">Project end date :</Typography>
                  <Typography variant="body2" color={Palette.grey[600]} >
                    {
                      data?.projectEndDate ? dayjs(data?.projectEndDate).format("DD/MM/YYYY") : "--"
                    }
                  </Typography>
                </Grid>
                <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                  <Typography variant="body1">Project status :</Typography>
                  <Typography variant="body2" color={Palette.grey[600]} >{data?.projectStatus ? data?.projectStatus : "--"}</Typography>
                </Grid>
                <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                  <Typography variant="body1">Project Amounts  :</Typography>
                  <Typography variant="body2" color={Palette.grey[600]} >{data?.projectAmounts ? data?.projectAmounts : "--"}</Typography>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Card>
      )}

    </div>
  )
}

export default Overview
